import React, { useState, useRef } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import withRouter from "components/Common/withRouter"
import classnames from "classnames"
import AuthenticationApi from "Api/AuthenticationApi"
import { editProfile } from "store/actions"
import { Toast } from "primereact/toast"

const Settings = () => {
  document.title = "Settings | Admin"
  const dispatch = useDispatch()
  const accessToken = localStorage.getItem("accessToken")
  const userData = JSON.parse(localStorage.getItem("userData"))
  const toast = useRef(null)
  const [activeTab, setActiveTab] = useState("1")

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  // const selectProfileState = state => state.Profile
  // const ProfileProperties = createSelector(selectProfileState, profile => ({
  //   error: profile.error,
  //   success: profile.success,
  // }))

  // const { error, success } = useSelector(ProfileProperties)



  const passwordValidation = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("Please enter your old password."),
      newPassword: Yup.string()
        .min(6, "Password must be at least 6 characters long.")
        .required("Please enter a new password."),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const config = { headers: { Authorization: `Bearer ${accessToken}` } }
        await AuthenticationApi.changePassword(
          {
            email: userData.email,
            oldPassword: values.oldPassword,
            password: values.newPassword,
          },
          config,
        )
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Password updated successfully!",
          life: 3000,
        })
        resetForm()
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to update password. Please try again.",
          life: 3000,
        })
      }
    },
  })

  return (
    <>
      <Toast ref={toast} />
      <div className="page-content p-4">
        <Container fluid>
          <Row>
            <Col lg="12">
              <h4 className="mb-4"> Settings</h4>

              <Nav tabs className="nav-tabs-custom mb-3">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => toggleTab("1")}
                  >
                    Change Password
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <Row>
                    <Col lg="12">
                      <Card>
                        <CardBody>
                          <Form onSubmit={passwordValidation.handleSubmit}>
                            <div className="mb-3">
                              <Label>Current Password</Label>
                              <Input
                                name="oldPassword"
                                placeholder="Enter current password"
                                type="password"
                                onChange={passwordValidation.handleChange}
                                onBlur={passwordValidation.handleBlur}
                                value={passwordValidation.values.oldPassword}
                                invalid={
                                  passwordValidation.touched.oldPassword &&
                                  !!passwordValidation.errors.oldPassword
                                }
                              />
                              {passwordValidation.touched.oldPassword &&
                                passwordValidation.errors.oldPassword && (
                                  <FormFeedback type="invalid">
                                    {passwordValidation.errors.oldPassword}
                                  </FormFeedback>
                                )}
                            </div>

                            <div className="mb-3">
                              <Label>New Password</Label>
                              <Input
                                name="newPassword"
                                placeholder="Enter new password"
                                type="password"
                                onChange={passwordValidation.handleChange}
                                onBlur={passwordValidation.handleBlur}
                                value={passwordValidation.values.newPassword}
                                invalid={
                                  passwordValidation.touched.newPassword &&
                                  !!passwordValidation.errors.newPassword
                                }
                              />
                              {passwordValidation.touched.newPassword &&
                                passwordValidation.errors.newPassword && (
                                  <FormFeedback type="invalid">
                                    {passwordValidation.errors.newPassword}
                                  </FormFeedback>
                                )}
                            </div>

                            <div className="text-end">
                              <Button type="submit" color="primary">
                                Change Password
                              </Button>
                            </div>
                          </Form>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default withRouter(Settings)
